import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class CloudVpcDeleteModal extends Component {
  render() {
    const { showBrowserModal, closeModal, deleteVpcData, rowData } = this.props;

    return (
      <Modal show={showBrowserModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="fas fa-exclamation-triangle text-warning fa-3x mb-3"></i>
            <p>Are you sure you want to delete the VPC device with MAC:</p>
            <h5 className="text-danger">{rowData?.row?.mac_id}</h5>
            <p className="text-muted small">This action cannot be undone and may disrupt device connectivity.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" className="text-dark" onClick={closeModal}>
            No, Keep it
          </Button>
          <Button variant="danger" onClick={() => deleteVpcData(rowData)}>
            Yes, Delete Device
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CloudVpcDeleteModal;
